import FlipCountdown from './FlipCountdown';

export default FlipCountdown;
